import type { KanbanSwimlane } from '@workbuddy/ui/v2/components/kanban';

/** Cards in reading order: lane by lane, column by column. A collapsed lane or column hides its cards, so they are not stepped to. */
export function boardCardVisibleOrder(swimlanes: readonly KanbanSwimlane[], keyOf: (item: unknown) => string | null | undefined): string[] {

  const order: string[] = [];
  for (const lane of swimlanes) {
    if (lane.collapsed) continue;
    for (const column of lane.columns ?? []) {
      if (column.collapsed) continue;
      for (const item of column.items ?? []) {
        const id = keyOf(item);
        if (id != null && id !== '') order.push(id);
      }
    }
  }
  return order;
}
